import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ApiService } from 'src/app/services/api/api.service';
import SwiperCore, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/core';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Navigation, Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-pb-testimonials',
    templateUrl: './pb-testimonials.component.html',
    styleUrls: ['./pb-testimonials.component.scss']
})
export class PbTestimonialsComponent implements OnInit {

    @Input() module: any = {};
    @Input() content: any = {};
    padding_top: any = '';
    padding_bottom: any = '';

    quotes: any = [];
    isBeginWhy: boolean = true;
    isEndWhy: boolean = false;
    whySwiperInstance: any;
    waySwiperInstance: any;
    wayIndex = 0;
    tags: any = '';

    // A swiper config which is responsive and doesn't show partial slides and only shows 1 slide
    public standardConfig: any = {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true, // Automatically hides pagination when not needed
        pagination: { clickable: true },
        navigation: {
            nextEl: '.custom-next',
            prevEl: '.custom-prev'
        },
        loop: false,
        // breakpoints: {
        //     576: {
        //         navigation: {
        //             nextEl: '.custom-next',
        //             prevEl: '.custom-prev'
        //         },
        //         pagination: true
        //     }
        // }
    };

    constructor(
        private api: ApiService,
        private cd: ChangeDetectorRef,
        @Inject(PLATFORM_ID) private platformId: object
    ) { }

    ngOnInit(): void {

        this.content.forEach(element => {
            this.tags = element.data;
        });

        try {
            this.tags = JSON.parse(this.tags);
            this.tags = this.tags.join();
        } catch (err) {
            this.tags = [];
        }

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

        this.fetchQuotes();

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding === 'SMALL') {
            return '10';
        } else if (padding === 'MEDIUM') {
            return '15';
        } else if (padding === 'LARGE') {
            return '30';
        } else if (padding === 'XLARGE') {
            return '60';
        }

    }

    /**
     * Fetches customer quotes
     */
    async fetchQuotes() {

        if (this.tags != '') {
            await this.api.fetch_quotes('?tags=' + this.tags)
                .subscribe(res => {
                    this.quotes = res.data.items;
                    this.quotes.forEach((item, index) => {
                        this.quotes[index].quote = JSON.parse(item.quote); 
                    });

                    if (this.quotes.length == 1) {
                        this.isBeginWhy = true;
                        this.isEndWhy = true;
                    }

                    this.cd.detectChanges();
                }, (err) => {

                });
        } else {
            await this.api.fetch_quotes()
                .subscribe(res => {
                    this.quotes = res.data.items;
                    this.quotes.forEach((item, index) => {
                        this.quotes[index].quote = JSON.parse(item.quote); 
                    });

                    if (this.quotes.length == 1) {
                        this.isBeginWhy = true;
                        this.isEndWhy = true;
                    }

                    this.cd.detectChanges();
                }, (err) => {

                });
        }

    }

    /**
     * When 'Ways you can study' swiper is ready then issue update so that the sizing is correct
     * @param swiper
     */
    onWaySwiper(swiper) {

        this.waySwiperInstance = swiper;

        if (!swiper || !isPlatformBrowser(this.platformId)) {
            return;
        }

        setTimeout(() => {
            if (!swiper.destroyed) {
                swiper.update();
            }
        }, 1500);

    }

    /**
     * Using slidechange to disable / enable the next and previous buttons
     */
    onWaySlideChange() {

        if (this.waySwiperInstance) {
            this.wayIndex = this.waySwiperInstance.realIndex;

            this.cd.detectChanges();
        }

    }

    /**
     * When 'Why people love IBTC' swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onWhySwiper(swiper) {

        this.whySwiperInstance = swiper;

        if (!swiper || !isPlatformBrowser(this.platformId)) {
            return;
        }

        setTimeout(() => {
            if (!swiper.destroyed) {
                swiper.update();
            }
        }, 1500);

    }

    /**
     * Using slidechange to disable / enable the next and previous buttons
     */
    onWhySlideChange() {

        this.isBeginWhy = this.whySwiperInstance.isBeginning;
        this.isEndWhy = this.whySwiperInstance.isEnd;

    }

    /**
     * Slides to the next image
     */
    gotoWhyNext() {

        this.whySwiperInstance.slideNext();

    }

    /**
     * Slides to the previous image
     */
    gotoWhyPrevious() {

        this.whySwiperInstance.slidePrev();

    }

}
